export const quantumPageFR = {
  "seo": {
    "title": "LLM Souverains & IA Quantique | pAIoneer Labs GmbH",
    "description": "Notre objectif depuis l'Allemagne : sous Veridion (« l'IA fait évoluer l'IA »), développer des modèles de langage compacts et des Quantum Transformers qui rivaliseront avec les grands modèles américains et chinois."
  },
  "hero": {
    "kicker": "Made in Germany · L'IA développe l'IA",
    "title": "LLM Souverains & IA Quantique",
    "claim": "Notre objectif depuis l'Allemagne : développer nos propres modèles de langage et Quantum Transformers, qui rivaliseront demain avec les grands modèles des États-Unis et de la Chine.",
    "subtitle": "Dans des projets d'entreprise réels, les approches européennes actuelles — les modèles allemands d'Aleph Alpha (comme Kolibri), les modèles français autour de Mistral, EuroLLM et surtout le modèle suisse Apertus — ont été évaluées face à de vrais problèmes métiers. Aucun ne répond aux exigences des entreprises. C'est pourquoi notre IA sous [Veridion](veridion) (« l'IA fait évoluer l'IA ») franchit l'étape suivante : elle prépare la voie vers des modèles de langage compacts Made in Germany qui seront bien plus performants que les modèles français, et développe en second axe ses propres Quantum Transformers.",
    "cta": "Planifier un entretien"
  },
  "pillars": {
    "title": "Sur quoi travaille notre IA",
    "subtitle": "Deux axes de recherche dans lesquels nos collaborateurs numériques conçoivent de nouvelles architectures, les testent en simulation et les construisent pas à pas.",
    "items": [
      {
        "title": "Ce qu'un modèle doit accomplir au quotidien",
        "description": "En production, seuls comptent le raisonnement logique à plusieurs étapes, l'usage fiable d'outils sur de longues chaînes, le développement logiciel propre et des processus bureautiques sans erreur. Nous y mesurons chaque architecture dès le départ."
      },
      {
        "title": "Des modèles compacts pour votre propre infrastructure",
        "description": "Plutôt que des centres de calcul toujours plus massifs, notre objectif sera de concentrer une grande profondeur de raisonnement dans un modèle compact exploitable localement sur le matériel de l'entreprise."
      },
      {
        "title": "Quantum Transformers & IA Quantique",
        "description": "Dans notre second axe, nous étudions comment associer architectures transformer, circuits quantiques paramétrés et réseaux de tenseurs pour ouvrir de nouvelles classes de modèles."
      },
      {
        "title": "Quantum IDE propre & processeurs quantiques réels",
        "description": "Dans notre propre Quantum IDE, nos collaborateurs IA conçoivent, simulent et testent de nouveaux circuits quantiques face aux références classiques avant leur exécution sur matériel quantique réel."
      }
    ]
  },
  "gate": {
    "title": "De l'état de l'art au plan de construction",
    "subtitle": "Chaque étape s'appuie sur la littérature vérifiée, notre mémoire d'entreprise et des comparaisons mesurables.",
    "stages": [
      {
        "step": "Étape 01",
        "title": "Analyse scientifique & mémoire d'entreprise",
        "description": "Nos collaborateurs IA analysent en continu les dernières publications sur les architectures de modèles et le quantique, et inscrivent chaque résultat vérifié dans notre graphe de connaissances."
      },
      {
        "step": "Étape 02",
        "title": "Feuille de route d'entraînement & simulation",
        "description": "Avec le Développement Produit naît ainsi le plan d'entraînement détaillé de notre futur modèle de langage, tandis que de nouveaux circuits quantiques sont testés dans la Quantum IDE."
      },
      {
        "step": "Étape 03",
        "title": "Examen scientifique dans le processus IDD",
        "description": "Physiciens et chercheurs IA vérifient chaque hypothèse, chaque mesure et chaque conception via l'[Intent-Driven Development](idd) (IDD) en human-in-the-loop avant de valider l'étape suivante."
      }
    ]
  },
  "stack": {
    "title": "Humains et IA dans une même unité de recherche",
    "subtitle": "Recherche, développement produit et supervision scientifique s'articulent en cycles fixes.",
    "items": [
      {
        "title": "Chercheurs numériques en continu",
        "description": "Des collaborateurs IA spécialisés assurent veille scientifique, dérivations mathématiques, conception de circuits et évaluation jour et nuit."
      },
      {
        "title": "Physiciens en Human-in-the-Loop",
        "description": "Les scientifiques humains fixent le cap de recherche, mettent les hypothèses à l'épreuve et décident des validations, exécutions matérielles et publications."
      },
      {
        "title": "Articulation avec le Développement Produit",
        "description": "En lien étroit avec notre équipe produit, les résultats de recherche validés alimentent directement nos outils et nos futures solutions d'entreprise."
      },
      {
        "title": "Traçable jusqu'à la source",
        "description": "Chaque choix d'architecture, chaque variante écartée et chaque mesure reste documenté durablement et vérifiable à tout moment."
      }
    ]
  },
  "cta": {
    "title": "Échange autour de la recherche",
    "subtitle": "Vous souhaitez échanger sur nos travaux autour des modèles de langage souverains et des Quantum Transformers ? Écrivez-nous.",
    "button": "Écrire un message"
  }
};
